import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'ca-page-size-selection',
    templateUrl: './page-size-selection.component.html',
    styleUrls: ['./page-size-selection.component.scss'],
})
export class PageSizeSelectionComponent implements OnInit, AfterViewInit {
    /**
     * The unique storage key for persisting the selected page size.
     * This allows different components to store their page size independently.
     */
    @Input() pageSizeStorageKey = 'filesPageSize';

    @Output() pageSizeChange = new EventEmitter<number>();
    @ViewChild('pageSizeSelect', { static: false }) pageSizeSelect!: ElementRef;

    selectedPageSize = '10';

    ngOnInit(): void {
        // Retrieve the saved page size using the unique storage key
        const savedSize = localStorage.getItem(this.pageSizeStorageKey);
        if (savedSize) {
            this.selectedPageSize = savedSize;
        }

        this.pageSizeChange.emit(parseInt(this.selectedPageSize, 10));
    }

    /**
     * Lifecycle hook that runs after the view has been initialized.
     * Ensures the zui-select component is assigned the stored page size.
     */
    ngAfterViewInit(): void {
        if (this.pageSizeSelect) {
            this.pageSizeSelect.nativeElement.value = [this.selectedPageSize];
        }
    }

    /**
     * Handles the selection change event.
     * Updates the selected value in localStorage and emits the new value.
     *
     * @param event - The event object containing the selected value.
     */
    onSelectionChange(event: Event): void {
        const target = event.target as HTMLSelectElement;

        if (target && target.value) {
            const selectedValue = target.value;
            localStorage.setItem(this.pageSizeStorageKey, selectedValue);
            this.pageSizeChange.emit(parseInt(selectedValue, 10));
        }
    }
}
